// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".joblisitng_search {\n  width: 18rem;\n}\n.b-custom_pagination_classes {\n  padding: 0;\n  background-color: transparent !important;\n}", ""]);
// Exports
module.exports = exports;
